import React from 'react'
import ReactDOM from 'react-dom/client'
import { Provider } from "react-redux";
import configureStore from "./Redux/Store/Store";
import App from './App'
import './assets/styles/general.scss'
import * as Sentry from '@sentry/react'
import { Integrations } from '@sentry/tracing'

Sentry.init({
  dsn: "https://c9b2764e895903c0f7098bfe8585393b@sentry.bimeh.com/18",
  integrations: [new Integrations.BrowserTracing()],
  tracesSampleRate: 1.0,
  sendDefaultPii: true
})

const store = configureStore(window.__PRELOADED_STATE__);
const root = ReactDOM.createRoot(document.getElementById('root'))
root.render(
  <React.StrictMode>
    <Sentry.ErrorBoundary fallback={'An error has occurred'}>
      <Provider store={store}>
        <App />
      </Provider>
    </Sentry.ErrorBoundary>
  </React.StrictMode>
)




